export const referrals = {
  menu: {
    label: "Empfehlen & verdienen",
    badge: "Verdienen",
  },
  welcomeCard: {
    title: "Ihr Tarif könnte kostenlos sein",
    desc: "Laden Sie andere Gastgeber ein und erhalten Sie dauerhaft einen Anteil an allem, was sie zahlen.",
  },
  page: {
    loading: "Ihre Empfehlungen werden geladen…",
    previewNotice: "Vorschau mit Beispieldaten. Ihre echten Empfehlungen erscheinen hier, sobald das Programm startet.",
  },
  hero: {
    title: "Laden Sie andere Gastgeber ein und nutzen Sie WACheckin kostenlos",
    subtitle: "Für jeden Gastgeber, der über Ihren Link abschließt, erhalten Sie {percent} % von allem, was er zahlt, jeden Monat, dauerhaft. Ihre Kollegin oder Ihr Kollege startet mit {friendPercent} % Rabatt.",
    personal: "Ihr Tarif kostet {price} pro Monat. Mit {count} Empfehlungen wie Ihnen zahlen Sie nie wieder.",
    personalGeneric: "Mit {count} zahlenden Gastgebern wie Ihnen ist Ihr Tarif kostenlos.",
  },
  rewards: {
    youGet: "Sie erhalten",
    youGetBig: "{percent} % jeder Zahlung",
    youGetSmall: "von jedem Gastgeber, den Sie einladen, jeden Monat, dauerhaft",
    friendGets: "Sie oder er erhält",
    friendGetsBig: "{percent} % Rabatt",
    friendGetsSmall: "in den ersten {months} Monaten",
    example: "Wenn Sie einen Gastgeber mit {units} Apartments einladen, verdienen Sie rund {amount} pro Jahr, solange er bleibt.",
  },
  welcomeOffer: {
    title: "Ihr Willkommensgeschenk",
    text: "{name} hat Sie zu WACheckin eingeladen: Sie erhalten {percent} % Rabatt in den ersten {months} Monaten. Er wird beim Abschluss angewendet.",
  },
  share: {
    title: "Ihr Einladungslink",
    codeLabel: "Ihr Code",
    copy: "Link kopieren",
    copied: "Kopiert",
    whatsapp: "WhatsApp",
    invite: "Per E-Mail senden",
    more: "Mehr",
    message: "Schauen Sie sich WACheckin an: Ich nutze es für den Online-Check-in, die Gästekommunikation und die Anbindung von Booking und Airbnb, und es spart mir viel Zeit. Mit meinem Link erhalten Sie {percent} % Rabatt in den ersten {months} Monaten: {link}",
    emailSubject: "Mit meinem Link {percent} % Rabatt auf WACheckin sichern",
  },
  invite: {
    title: "Per E-Mail einladen",
    subtitle: "Wir senden eine persönliche Einladung mit Ihrem Link und dem Rabatt von {percent} %.",
    emailLabel: "E-Mail der Kollegin oder des Kollegen",
    emailPlaceholder: "name@firma.com",
    languageLabel: "Sprache der E-Mail",
    cancel: "Abbrechen",
    send: "Einladung senden",
    sending: "Wird gesendet…",
    successTitle: "Einladung gesendet!",
    successDesc: "Wir haben Ihre Einladung an {email} gesendet.",
    another: "Weitere Person einladen",
    close: "Schließen",
    errors: {
      invalidEmail: "Geben Sie eine gültige E-Mail-Adresse ein.",
      selfInvite: "Sie können die Einladung nicht an Ihre eigene E-Mail-Adresse senden.",
      alreadyInvited: "Sie haben diese E-Mail-Adresse vor Kurzem bereits eingeladen. Versuchen Sie es in ein paar Tagen erneut.",
      dailyLimit: "Sie haben das heutige Einladungslimit erreicht. Versuchen Sie es morgen erneut.",
      tooFast: "Zu viele Versuche hintereinander. Warten Sie eine Minute und versuchen Sie es erneut.",
      generic: "Die Einladung konnte nicht gesendet werden. Bitte versuchen Sie es erneut.",
    },
  },
  message: {
    title: "Fertige Nachricht zum Teilen",
    hint: "Fügen Sie sie in Ihre Gastgeber-Gruppen, Foren oder sozialen Netzwerke ein. Am besten wirkt sie mit einer eigenen Zeile von Ihnen.",
    copy: "Nachricht kopieren",
  },
  how: {
    title: "So funktioniert es",
    stepLabel: "Schritt {n}",
    step1Title: "Teilen Sie Ihren Link",
    step1Desc: "Per WhatsApp, E-Mail oder in Ihren Gastgeber-Gruppen.",
    step2Title: "Der Abschluss erfolgt mit Rabatt",
    step2Desc: "Die Registrierung läuft über Ihren Link und startet mit {percent} % Rabatt.",
    step3Title: "Sie verdienen jeden Monat",
    step3Desc: "{percent} % jeder Zahlung fließen dauerhaft in Ihr Guthaben. Die erste zählt nach {days} Tagen.",
  },
  results: {
    title: "Ihre Ergebnisse",
    celebrate: "Sie haben bisher {amount} verdient.",
    coverage: "Ihre Empfehlungen decken bereits {percent} % Ihres Tarifs",
    coverageFree: "Ihr Tarif ist bereits kostenlos",
    coverageHint: "Ihr Tarif kostet {price} pro Monat und Ihre Empfehlungen bringen Ihnen {earning} pro Monat.",
  },
  stats: {
    invited: "Eingeladen",
    subscribed: "Zahlend",
    monthlyEarning: "Monatlicher Verdienst",
    creditAvailable: "Verfügbares Guthaben",
    creditEarned: "{amount} insgesamt verdient",
    creditHint: "Wird automatisch von Ihrer nächsten Rechnung abgezogen",
  },
  list: {
    title: "Ihre Empfehlungen",
    colName: "Konto",
    colDate: "Registriert",
    colStatus: "Status",
    colReward: "Ihr Verdienst",
    empty: "Sie haben noch niemanden eingeladen. Der erste Gastgeber, der über Ihren Link abschließt, bringt Ihnen jeden Monat Guthaben.",
  },
  status: {
    registered: "Registriert",
    subscribed: "Zahlend",
    rewarded: "Verdienend",
    canceled: "Gekündigt",
    rejected: "Nicht berechtigt",
  },
  reward: {
    waiting: "Warten auf die erste Zahlung",
    startsOn: "Sie beginnen am {date} zu verdienen",
    earning: "{monthly} pro Monat, {earned} insgesamt",
    earningNoPlan: "{earned} insgesamt",
    canceled: "{earned} verdient",
  },
  reasons: {
    duplicate: "Doppeltes Konto",
    selfReferral: "Eigenempfehlung",
  },
  faq: {
    title: "Häufige Fragen",
    howMuchQ: "Wie viel verdiene ich?",
    howMuchA: "{percent} % von allem, was jeder von Ihnen eingeladene Gastgeber zahlt (ohne Steuern), jeden Monat und dauerhaft, ohne Begrenzung der Empfehlungen. Zahlt er {price} pro Monat, verdienen Sie etwa {amount} pro Monat.",
    whenQ: "Wann erhalte ich es?",
    whenA: "Jedes Mal, wenn Ihre Empfehlung zahlt, wird der Betrag automatisch Ihrem Guthaben gutgeschrieben. Die erste Zahlung zählt nach {days} Tagen, für den Fall einer Kündigung direkt nach Abschluss.",
    whereQ: "Wofür wird das Guthaben verwendet?",
    whereA: "Es wird automatisch von Ihren nächsten WACheckin-Rechnungen abgezogen. Wenn Sie noch keinen Tarif haben, wird es auf Ihre erste Rechnung angewendet.",
    limitQ: "Gibt es ein Limit?",
    limitA: "Es gibt keine Begrenzung der Empfehlungen oder der Dauer. Nur eine: Das angesparte und nicht genutzte Guthaben reicht bis zu {months} Monate Ihres Tarifs. Solange Sie an dieser Grenze sind, bleibt Ihr Tarif kostenlos; darüber hinaus wird nichts angespart.",
    stopQ: "Wann höre ich auf zu verdienen?",
    stopA: "Kündigt Ihre Empfehlung, verdienen Sie an ihr nichts mehr. Kündigen Sie selbst, sammeln Sie kein Guthaben mehr an.",
    whoQ: "Wen kann ich einladen?",
    whoA: "Jeden Gastgeber oder jedes Hotel, das WACheckin noch nicht nutzt. Eigenempfehlungen und doppelte Konten sind nicht berechtigt.",
  },
};
